
import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Button,
} from 'element-ui';
import { IResource } from '@/types/course.d';
import api from '@/api/course';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Button,
  },
})
export default class ManageBusModal extends Vue {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: true,
    default: false,
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  private types: { value: number, label: string }[] = [{
    value: 0,
    label: '0',
  }];

  private form: any = {
    content: null,
  };

  private loading: boolean = false;

  private toolbarOptions: any = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }],
    [{ background: [] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ direction: 'rtl' }],
    [{ size: ['10px', false, '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px'] }],
    [{ font: ['serif', 'monospace', 'Microsoft YaHei'] }],
    [{ align: [] }],
    ['clean'],
    ['link', 'image'],
  ];

  public $refs!: {
    form: Form;
    tEditor: any;
  }

  mounted() {
    this.form = {
      backdropLibrary: this.oldForm.backdropLibrary,
      costumeLibrary: this.oldForm.costumeLibrary,
      soundLibrary: this.oldForm.soundLibrary,
      spriteLibrary: this.oldForm.spriteLibrary,
      stepId: this.oldForm.stepId,
      courseType: this.oldForm.courseType,
      difficulty: this.oldForm.difficulty,
      knowledge: this.oldForm.knowledge,
      pid: this.oldForm.pid,
      questionId: this.oldForm.questionId,
      questionType: this.oldForm.questionType,
      sort: this.oldForm.sort,
      content: this.oldForm.content,
    };
  }

  contentChange(content: string) {
    this.form.content = content;
  }

  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        api.editHomeWork(this.form).then(() => {
          this.reset(true, true);
          /* eslint-disable no-return-assign */
        }).catch(() => (this.loading = false));
      } else this.loading = false;
    });
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh', this.form.stepPid);
  }
}
